// extracted by mini-css-extract-plugin
module.exports = {"Component":"CustomerGiftTable_Component__uRCrd"};